import { Injectable, ElementRef } from '@angular/core';
export class HeaderService {
public elementRef: ElementRef;
/**
 * [offsetHeight description]
 * \@method offsetHeight
 * @return {?}
 */
public get offsetHeight(): number {
    return this.elementRef.nativeElement.offsetHeight;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function HeaderService_tsickle_Closure_declarations() {
/** @type {?} */
HeaderService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
HeaderService.ctorParameters;
/** @type {?} */
HeaderService.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
